import React from 'react';

export default function Home() {
  return (
    <>
      <h1>
        MeowDAO Governance Token
      </h1>
      <p>
        The MeowDAO ERC20 Governance token is a fully decentralized, trustless charity system.
        It was designed acknowledging current trends, but does not rely on particular
        market conditions in order to continue operating well into the distant future.
      </p>
      <h1>
        System Elements
      </h1>
      <p>
        Many charity tokens function using transaction fees. While these mechanisms work when a token
        is traded on decentralized exchanges directly, derived trading environments like
        centralized exchanges will optimize away their effects. Efficient markets are inevitable;
        long lasting products cannot depend on the inefficiencies of specific contexts in order
        to operate.  That being said, nascent tokens survive by building excitement. To ensure
        a successful launch, MEOW transactions have a 1% charity fee that scales down to 0% one year
        after deployment.
      </p>
      <p>
        Staking yields are the preferred method of delivering value while trading activity occurs
        in arbitrary contexts. Yields are generated by manually staking your wallet. Staked wallets
        generate 7% APY. When a charity wallet is selected by the voting process, an additional 3%
        of the wallet value will go to the chosen wallet per year. Unstaking locks the wallet
        from making transactions for 5 days.
      </p>
      <p>
        The charity wallet is selected by votes cast by the staked wallets, weighted proportionally
        to the amount of tokens held by each voter. Inflation from the charity yield can be disabled
        by voting for the zero Ethereum address.
      </p>
      <h1>
        Future Developments
      </h1>
      <p>
        While the MEOW token functions as a complete system, further developments are possible.
        The MEOW smart contract features an API for other contracts to derive staking rewards from,
        based on the amount of tokens held in a wallet at the time of staking.
        This allows the governance token to be the basis for a charitable ecosystem,
        where derived yield can be redirected to the charity wallet selected by the stake holders.
      </p>
    </>
  )
}
